import { render, staticRenderFns } from "./newCertificate.vue?vue&type=template&id=6ba2aa7e"
import script from "./newCertificate.vue?vue&type=script&lang=js"
export * from "./newCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports